export const AUTH_CALLBACK_QUERY_PARAM = 'authCallback';
export const AUTH_CALLBACK_QUERY_VALUE = '1';
